<p>form-single-stat works!</p>
